// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__n_7HS","logo":"styles_logo__vMSiy","menu":"styles_menu__0Jn_6","menuItem":"styles_menuItem__0hFIh","btn":"styles_btn__Xi338"};